import { FetchProxy } from "intraactive-sdk-helper";
import { sdkContainerInstance } from "../global/Container";
import { IEnvironment } from "../interfaces/IEnvironment";
import { Environment } from "./Environment";

export default class AdvancedSettingsService {
  public static get(environment: IEnvironment, token: string, tenant: string): Promise<any[]> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForSettingsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      }
    });
  }

  public static getSetting(environment: IEnvironment, token: string, tenant: string, setting: string): Promise<{key:string, value:string}> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForSettingsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/admin/${setting}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      }
    });
  }

  public static getAppSetting(environment: IEnvironment, token: string, tenant: string, setting: string): Promise<{key:string, value:string}> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForSettingsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/app/${setting}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      }
    });
  }

  public static update(environment: IEnvironment, token: string, tenant: string, group: string, key: string, value: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (environment && tenant && token && group && key && value) {
        const apiUrl = `${Environment.getEnvironmentForSettingsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/${group}/${key}`;
        new FetchProxy(apiUrl, {
          method: "POST",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }),
          body: JSON.stringify({ "value": value })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            console.log(response);
            resolve();
          }).catch(error => {
            console.log(error);
            reject();
          });
      } else {
        reject();
      }
    });
    
  }
}